var map = {
	"./calendarDate.js": 53,
	"./calendarLimitTo.js": 54,
	"./calendarTruncateEventTitle.js": 55,
	"./calendarTrustAsHtml.js": 56
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;



/*****************
 ** WEBPACK FOOTER
 ** ./src/filters \.js$
 ** module id = 64
 ** module chunks = 0
 **/